<template>
  <!-- 공지 팝업 추가 -->
  <div class="layer-notice">
    <div class="layer-notice__inner">
        <div class="layer-notice__carousel" id="noticeCarousel">
        <template v-for="(item, index) in noticeList" >
            <div class="carousel__item" :key="index">
                <div class="layer-notice__title">
                    <h2 class="layer-notice__title-text">
                        {{item.title}}
                    </h2>
                    <!-- <p class="layer-notice__period">
                        {{item.start_date}} ~ {{item.end_date}}
                    </p> -->
                </div>
                <div class="layer-notice__scroll">
                  <div class="edit_content" v-html="item.notice"></div>
                </div>
            </div>
        </template>
        </div>
        <div class="layer-notice__buttons">
            <button type="button" class="button" data-button="today" @click="closePopupToday">오늘 그만 보기</button>
            <button type="button" class="button button--primary" data-button="close" @click="closePopup">닫기</button>
        </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'NoticePopup',
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
    noticeList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
    };
  },
  mounted() {
    this.$nextTick(() => {
      var carousel = $('#noticeCarousel');
      var noticeLayer = $('.layer-notice');
      carousel.owlCarousel({
            items: 1,
            autoWidth: false,
            nav: true,
            dots: true,
        });
    })
  },
  methods: {
    setCookie( name, value, expiredays ) {
        var todayDate = new Date();
        todayDate.setDate( todayDate.getDate() + expiredays );
        document.cookie = name + "=" + escape( value ) + "; path=/; expires=" + todayDate.toGMTString() + ";"

        /* todayDate.setTime( todayDate.getTime() + (expiredays*24*60*60*10000) );
        document.cookie = name + "=" + escape( value ) + "; path=/; expires=" + todayDate.toUTCString() + ";"
        console.log('::::::::::::::::::::::::::::::::::::expiredays')
        console.log(todayDate.getDate())
        console.log(todayDate.toGMTString())
        console.log(todayDate.toUTCString()) */
    },
    closePopup (){
        console.log('child close')
        this.$emit('change-actice');
    },
    closePopupToday (){
        this.setCookie('noticeToday', 'close', 1);
        this.$emit('change-actice');
    },
    handleNewLine(str) {
      return String(str).replace(/(?:\r\n|\r|\n)/g,"</br>");
   }
  }
};

</script>

<style scoped>
p,
ul,
ol,
dl,
dt,
dd {
  background-color: red;
}

.layer-notice__scroll.li {
  background-color: red;
}

</style>
